export const TRAIN_TYPE_ID = 2;
export const BUS_TYPE_ID = 3;
export const FERRY_TYPE_ID = 4;

export const TRIP_DIRECTION_OUTBOUND = 1;
export const TRIP_DIRECTION_INBOUND = 0;

// User-facing text for a trip's direction. Mode-agnostic: bus, train and ferry
// all read the same, and route variant names keep their own clockwise /
// anticlockwise wording independently of these labels.
export const DIRECTION_DISPLAY_LABELS = {
    [TRIP_DIRECTION_INBOUND]: 'Inbound',
    [TRIP_DIRECTION_OUTBOUND]: 'Outbound',
};

export const getDirectionDisplayLabel = directionId => DIRECTION_DISPLAY_LABELS[directionId];

export const VEHICLE_TYPES = ['Bus', 'Train', 'Ferry'];

export const VEHICLE_POSITION = 'vehiclePosition';

export default {
    [TRAIN_TYPE_ID]: {
        type: 'Train',
        className: 'vehicle-type-train',
    },
    [BUS_TYPE_ID]: {
        type: 'Bus',
        className: 'vehicle-type-bus',
    },
    [FERRY_TYPE_ID]: {
        type: 'Ferry',
        className: 'vehicle-type-ferry',
    },
    NIS: {
        type: 'NIS',
        className: 'vehicle-type-not-in-service',
    },

};

export const UNSCHEDULED_TAG = 'UNSCHEDULED';
export const UNSCHEDULED_VEHICLE_CLASS = 'unscheduled';

export const EXTENDED_ROUTE_TYPE = {
    schoolBus: 712,
};
